import React from "react"
import { motion } from "framer-motion"
import "./Home.css"
import hero from "../pic/rasm2.png"
// import rasm from "../pic/rasm.png/"
import skill1 from "../pic/skill1.png"
import skill2 from "../pic/skill2.png"
import skill3 from "../pic/skill3.png"
import { Typewriter } from "react-simple-typewriter"
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TelegramIcon from '@mui/icons-material/Telegram';
import GitHubIcon from '@mui/icons-material/GitHub';

const textAnimation = {
  hidden: {
    x: -100,
    opacity: 0,
  },
  visible: custom => ({
    x: 0,
    opacity: 1,
    transition: { delay: custom * 0.3 },
  }),
}

const Home = () => {
  return (
    <>
      <motion.section
        initial="hidden"
        whileInView="visible"
        className='hero' id='home'
      >
        <div className='container f_flex top'>
          <div className='left top'>
            <motion.h3 custom={1} variants={textAnimation}>WELCOME TO MY WORLD</motion.h3>
            <motion.h1 custom={2} variants={textAnimation}>
              Hi, I’m <span>Sherzod Tashpolatov</span>
            </motion.h1>
            <motion.h2 custom={3} variants={textAnimation}>
              and I'm
              <span>
                <Typewriter words={[" Freelancer. ", " Web Developer."]} loop cursor cursorStyle='|' typeSpeed={70} deleteSpeed={50} delaySpeed={1000} />
              </span>
            </motion.h2>

            <motion.p custom={4} variants={textAnimation}>Don't leave today's work for tomorrow.</motion.p>

            {/* <div className='hero_btn d_flex'> */}
              {/* <div className='col_1'> */}
                {/* <h4>FIND WITH ME</h4> */}
                {/* <div className='button'> */}
                  {/* <button className='btn_shadow'>
                    <i class='fab fa-facebook-f'></i>
                    <a href="https://www.facebook.com/profile.php?id=100054789188742"><FacebookOutlinedIcon /></a>

                  </button> */}
                  {/* <button className='btn_shadow' >
                    <i class='fab fa-instagram'></i>
                    <a href="https://www.instagram.com/01werka/"><InstagramIcon /> </a>

                  </button> */}

                  {/* <button className='btn_shadow' >
                    <img src={skill1} alt='' />
                    <i class='fab fa-telegram'></i>
                    <a href="https://t.me/werka01"> <TelegramIcon /> </a>
                  </button> */}
                {/* </div> */}
              {/* </div> */}
              {/* <div className='col_1'> */}
                {/* <h4>For Developers</h4>

                <button className='btn_shadow'>
                  <i class='fab fa-GitHub'></i>
                  <a href="https://github.com/01werka"> <GitHubIcon /> </a>
                </button>
                <button className='btn_shadow'>
                  <i class='fab fa-linkedin-in'></i>
                  <a href="https://www.linkedin.com/in/sherzod-tashpolatov-b3baa922a/"><LinkedInIcon /></a>

                </button> */}


                {/* <button className='btn_shadow'>
                <i class='fab fa-GitHub'></i>
                  <a href="https://mail.google.com/mail/u/0/#inbox"> <GitHubIcon/> </a>
                </button> */}
              {/* </div> */}
            {/* </div> */}
          </div>
          <div className='right'>
            <div className='right_img'>
              <motion.img className="werimg" custom={5} variants={textAnimation} src={hero} alt='' />
            </div>
          </div>
        </div>
      </motion.section>
    </>
  )
}

export default Home
